import { useSearchParams } from "react-router-dom";
import StudentHome from "./StudentHome";
import StudentLessons from "./StudentLessons";
import StudentActivities from "./StudentActivities";
import StudentNotices from "./StudentNotices";
import StudentMore from "./StudentMore";

export default function StudentPortalRouter() {
  const [params] = useSearchParams();
  const view = params.get("view") || (params.get("aviso") ? "avisos" : "home");
  if (view === "aulas") return <StudentLessons />;
  if (view === "atividades") return <StudentActivities />;
  if (view === "avisos") return <StudentNotices />;
  if (view === "mais") return <StudentMore />;
  return <StudentHome />;
}
